import React, { useEffect, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { useQueryClient } from 'react-query';
import { Link } from 'react-router-dom';

import messages from 'messages';

function ThankYou({ ...props }) {
    const { formatMessage } = props.intl;

    const queryClient = useQueryClient();

    const { domain, name } = queryClient.getQueryData('restaurant') || '';
    const email = queryClient.getQueryData('sender')?.email || '';

    useEffect(() => {
        document.body.classList.add('dark');

        localStorage.clear();
        queryClient.setQueryData('bag', []);
        queryClient.setQueryData('transaction', {});
        queryClient.setQueryData('purchase', []);

        return () => {
            document.body.classList.remove('dark');
        };
    }, []);

    return (
        <Fragment>
            <header>
                <h1 data-test="name-restaurant">
                    <Link to={`/${domain}`}>{name}</Link>
                </h1>
            </header>

            <div className="page-wrapper page-thankyou">
                <h1>{formatMessage(messages.thankyouTitle)}</h1>

                <p>
                    {formatMessage(messages.thankyouDescription)} {email}
                </p>
            </div>
        </Fragment>
    );
}

export default injectIntl(React.memo(ThankYou));
